import React from 'react';
import "../css/heading.css";

const Heading = ({ variant = 'H6', className, children, ...props }) => {
  if (variant === 'H2') {
    return (
      <h2
        className={["heading", "heading-h2", className].filter(Boolean).join(" ")}
        {...props}>
        {children}
      </h2>
    );
  }
  return (
    <h6
      className={["heading", "heading-h6", className].filter(Boolean).join(" ")}
      {...props}
    >
      {children}
    </h6>
  );
};

export default Heading;